<h2 *ngIf="showTitle && question?.title && question?.type !== questionTypes.Text" class="question__innertitle u-margin-top-medium"
  innerHTML="{{ question?.title }}"></h2>
<h3 *ngIf="question?.subtitle" class="question__subtitle" innerHTML="{{ question?.subtitle }}"></h3>
<div class="cms-content u-margin-bottom-huge" *ngIf="question?.content" innerHTML="{{ question?.content }}"></div>
<div class="hint u-margin-bottom" *ngIf="question?.hint" innerHTML="{{ question?.hint }}"></div>
<ng-template captoQuestionChild></ng-template>
